/**
 * colors used as the default theme
 */
export const COLORS = {
  // white-to-black scale
  white: `hsl(0, 0%, 100%)`, // bg/card, active/tertiary, map element fill, input on primary, high contrast text on dark bg
  g098: `hsl(230, 16%, 98%)`, // bg/primary, grayish state color on dark bg
  g094: `hsl(206, 23%, 94%)`, // bg/secondary, inputOnCard, bg/(validation) messages, normal contrast text on dark bg
  g091: `hsl(216, 22%, 91%)`, // default disabled color
  g088: `hsl(217, 10%, 88%)`, // bg/cart, active/secondary,
  g075: `hsl(217, 10%, 75%)`, // low contrast text on dark, placeholder texts on light
  g043: `hsl(217, 13%, 43%)`, // empty feedback star, low contrast text on light bg, placeholder text on dark bg
  g031: `hsl(217, 10%, 31%)`, // bg/contrasted
  g018: `hsl(217, 46%, 18%)`, // normal contrast text on light bg, grayish state color on light bg
  black: `hsl(0, 0%, 0%)`, // high contrast text on light bg, mapElement

  speedlo: `hsl(8, 76%, 63%)`,
  speedloSecondary: `hsl(226, 63%, 20%)`,
  // placeholder colors that should always be replaced by company base colors
  conversion: `hsl(0, 0%, 0%)`, // active/conversion
  companyPrimary: `hsl(0, 0%, 0%)`, // bg/company, active/primary, special/company, mapElementHighlight

  // status colors, used for things like toasts or success/error icons
  // light variants are used as FG colors for icons and bg colors for MessageBox and Toast
  red: `hsl(0, 75%, 52%)`,
  redLight: `hsl(0, 71%, 78%)`,
  green: `hsl(145, 63%, 42%)`,
  greenLight: `hsl(128, 48%, 74%)`,
  blue: `hsl(219, 95%, 45%)`,
  blueLight: `hsl(206, 82%, 71%)`,
  yellow: `hsl(37, 85%, 56%)`,
  yellowLight: `hsl(51, 92%, 90%)`,

  // transparent colors – dark (td) and light (tl)
  td010: `hsla(0, 0%, 0%, 0.1)`, // divider on light bg
  td055: `hsla(0, 0%, 0%, 0.55)`, // company hero overlay
  td075: `hsla(0, 0%, 0%, 0.75)`, // company hero overlay
  td085: `hsla(0, 0%, 8%, 0.85)`, // modal overlay
  tl020: `hsla(0, 0%, 100%, 0.2)`, // divider on dark bg
}
